export default __webpack_public_path__ + "static/media/guardSolution.085f43fa.jpg";